/*
 * @Descripttion: 
 * @version: 
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2019-10-21 18:20:16
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2020-09-01 12:02:10
 */
import Vue from 'vue'
import VueRouter from 'vue-router';
import menus from './menu'
import { wxAuthorization, checkToken } from "@/api/api"


//404页面
const notFound = resolve => {
        require.ensure(['@/views/404.vue'], () => {
            resolve(require('@/views/404.vue'))
        }, 'notFound')
    }
    //登录页面
    // const login = resolve => {
    //     require.ensure(['@/views/Login.vue'], () => {
    //         resolve(require('@/views/Login.vue'))
    //     }, 'login')
    // }
    //公共主页面
const main = resolve => {
    require.ensure(['@/views/Main.vue'], () => {
        resolve(require('@/views/Main.vue'))
    }, 'main')
}

const routes = [
    //嵌套路由
    {
        path: '*',
        component: notFound,
        name: 'noPage',
        meta: {
            noTab: true
        }
    }, {
        path: '/',
        // redirect: '/login',
        component: main,
        children: menus,
        meta: {
            noTab: true
        }
        // }, {
        //   path: '/login',
        //   component: login,
        //   name: 'login',
        //     meta: {
        //       noTab: true
        //     }
    },

]

export default routes


// WEBPACK FOOTER //
// ./src/routes/index.js